import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { confirmUserGroupMembership, rejectUserGroupMembership } from "../../redux/actions/groupActions";
import { toast } from "react-toastify";
import GroupMemberRejectionForm from "./GroupMemberRejectionForm"
import $ from 'jquery';

function GroupMemberRequestControl({
    group,
    user,
    subjectUser,
    confirmUserGroupMembership,
    rejectUserGroupMembership
}) {

    const [reason, setReason] = useState({ description: "" });
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);

    useEffect(() => {


    }, [])

    function acceptMemberRequest(e) {
        e.preventDefault();
        confirmUserGroupMembership(subjectUser, group.id)
            .then(() => {
                toast.success(`${subjectUser.firstName} ${subjectUser.surname} Added to Group`);
            });
    }

    function rejectMemberRequest(e) {
        e.preventDefault();
        $('#rejectionReason').modal('show')
    }

    function onSaveRejection(e) {
        e.preventDefault();

        const errors = {};

        if (!reason.description || reason.description == "") {
            errors.rejectionReason = "A reason is required.";
            setErrors(errors);
            return;
        }

        setProcessing(true);

        rejectUserGroupMembership(subjectUser, group.id, reason)
            .then(() => {
                $('#rejectionReason').modal('hide')
                toast.success(`${subjectUser.firstName} ${subjectUser.surname} Membership Rejected`);
                setProcessing(false);
            });
    }

    function onChange(e) {
        var { name, value } = e.target;

        setReason(prevReason => ({
            ...prevReason,
            [name]: value
        }));
    }

    function onCancelSave(e) {
        e.preventDefault();
        $('#rejectionReason').modal('hide')
    }

    return (

        <React.Fragment>
            <div className="dropdown dropleft">
                <button className="btn btn-link" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="fas fa-ellipsis-h more-options"></span>
                </button>
                <div className="dropdown-menu" aria-labelledby="dLabel">
                    <a className="dropdown-item" onClick={acceptMemberRequest} href="#">Accept Request</a>
                    <a className="dropdown-item" onClick={rejectMemberRequest} href="#">Reject Request</a>
                </div>
            </div>

            <div className="modal fade" id="rejectionReason" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Member Request Rejection</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <GroupMemberRejectionForm
                                rejectionReason={reason}
                                errors={errors}
                                onChange={onChange}
                                onSave={onSaveRejection}
                                onCancel={onCancelSave}
                                processing={processing}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

GroupMemberRequestControl.propTypes = {
    user: PropTypes.object.isRequired,
    subjectUser: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    confirmUserGroupMembership: PropTypes.func.isRequired,
    rejectUserGroupMembership: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

const mapDispatchToProps = {
    confirmUserGroupMembership,
    rejectUserGroupMembership
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupMemberRequestControl);


// WEBPACK FOOTER //
// ./src/components/groups/GroupMemberRequestControl.js